import { createSelector } from 'reselect';
import { RootState } from 'store';

export const getCustomerState = createSelector(
    (state: RootState) => state.customer,
    customer => customer
);
